import './Story.css';
import { useParams, Link } from 'react-router-dom';
import storyList from '../stories/storyList.js'
import Footer from '../Footer.js';
import React from "react";

function Story(props) {
    let params = useParams();

    let storySelected = storyList.find ((story) =>
    story.shortName === params.storyShortName)

    if (typeof storySelected === "undefined") {
        return (
            <div className="notValid">
                <Link className="link" to="/" >
                                <p className="backButton"> back to home </p>
                            </Link>
                                        <Link className="link" to="/stories" >
                <p className="backButton secondBackButton"> back to all stories </p>
            </Link>
                <p className="notValidText"> {params.storyShortName} is not a valid story</p>
                <Footer/>
            </div>
        )
    }
    else 
    return (
        <div className="story">
            <Link className="link" to="/" >
                <p className="backButton"> back to home </p>
            </Link>
            <Link className="link" to="/stories" >
                <p className="backButton secondBackButton"> back to all stories </p>
            </Link>
            <h1 className="storyHeaderText"> {storySelected.title}</h1>
            <h2 className="storyAuthorText"> written by <a href="/authors" className="authorUnderline"> {storySelected.author}</a></h2>
            {storySelected.story.map((element, index) => (
                <div>
                    {element}
                </div>
            ))}
        <Footer/>
        </div>

    )

}

export default Story;